<template>
    <div>
        <div class="filters">
            <div class="filter">
                <ui5-label>Externe naam</ui5-label>
                <ui5-input
                    placeholder="Filteren op externe naam"
                    :value="filters.label.value"
                    @input="filters.label.value = $event.target.value"
                />
            </div>
            <div class="filter">
                <ui5-label>Groep</ui5-label>
                <ui5-input
                    placeholder="Filteren op groep"
                    :value="filters.productTypeGroup.value"
                    @input="
                        filters.productTypeGroup.value = $event.target.value
                    "
                />
            </div>
        </div>
        <ui5-table>
            <ui5-table-column
                slot="columns"
                popin-text="Acties"
            >
                <span>Acties</span>
            </ui5-table-column>
            <ui5-table-column
                slot="columns"
                popin-text="ID"
            >
                <span>ID</span>
            </ui5-table-column>
            <ui5-table-column
                slot="columns"
                popin-text="Externe naam"
            >
                <span>Externe naam</span>
            </ui5-table-column>
            <ui5-table-column
                slot="columns"
                popin-text="Sleutel"
            >
                <span>Sleutel</span>
            </ui5-table-column>
            <ui5-table-column
                slot="columns"
                popin-text="Code"
            >
                <span>Code</span>
            </ui5-table-column>
            <ui5-table-column
                slot="columns"
                popin-text="Volgorde"
            >
                <span>Volgorde</span>
            </ui5-table-column>
            <ui5-table-column
                slot="columns"
                popin-text="Tonen op prosite"
            >
                <span>Tonen op prosite</span>
            </ui5-table-column>
            <ui5-table-column
                slot="columns"
                popin-text="Automatisch verwerken"
            >
                <span>Automatisch verwerken</span>
            </ui5-table-column>
            <ui5-table-column
                slot="columns"
                popin-text="Leverancier"
            >
                <span>Leverancier</span>
            </ui5-table-column>
            <ui5-table-column
                slot="columns"
                popin-text="Groep"
            >
                <span>Groep</span>
            </ui5-table-column>
            <ui5-table-column
                slot="columns"
                popin-text="Lakbon als vliegenramen verwerken"
            >
                <span>Lakbon als vliegenramen verwerken</span>
            </ui5-table-column>
            <ui5-table-column
                slot="columns"
                popin-text="Afzonderlijke lakbon"
            >
                <span>Afzonderlijke lakbon</span>
            </ui5-table-column>

            <ui5-table-row
                v-if="suppliers && productTypeGroups && productTypes"
                :key="item.producttypeId"
                v-for="item in visibleProductTypes"
            >
                <ui5-table-cell class="actions-cell">
                    <i
                        class="fa fa-sliders"
                        @click="openEditProductionInfo(item)"
                    ></i>
                    <i
                        class="fa fa-pencil"
                        @click="openEditType(item.producttypeId)"
                    ></i>
                    <i
                        class="fa fa-list-ol"
                        @click="openSawlineDetails(item)"
                    ></i>
                    <i
                        class="fa fa-copy"
                        @click="duplicateType($event, item)"
                        :ref="'copy-' + item.producttypeId"
                    ></i>
                </ui5-table-cell>
                <ui5-table-cell class="id-cell">
                    {{ item.producttypeId }}
                </ui5-table-cell>
                <ui5-table-cell>{{ item.label }}</ui5-table-cell>
                <ui5-table-cell>
                    <span v-if="item.name">{{ item.name }}</span>
                    <span
                        v-else
                        class="no-key"
                    >
                        geen sleutel
                    </span>
                </ui5-table-cell>
                <ui5-table-cell>
                    {{ item.code ? item.code : '?' }}
                </ui5-table-cell>
                <ui5-table-cell>{{ item.sortBy }}</ui5-table-cell>
                <ui5-table-cell>
                    {{ outputBool(item.showOnProsite) }}
                </ui5-table-cell>
                <ui5-table-cell>
                    {{ outputBool(item.autoProcess) }}
                </ui5-table-cell>
                <ui5-table-cell>
                    {{ getNameById(item.supplierId) }}
                </ui5-table-cell>
                <ui5-table-cell>
                    {{
                        getItemPath(
                            item.productTypeGroupId,
                            productTypeGroups,
                            isDebug
                        )
                    }}
                </ui5-table-cell>
                <ui5-table-cell>
                    {{ outputBool(item.paintlistAsWindow) }}
                </ui5-table-cell>
                <ui5-table-cell>
                    {{ outputBool(item.separatePaintlist) }}
                </ui5-table-cell>
            </ui5-table-row>
        </ui5-table>
        <ui5-popover
            class="popover-duplicate-product-type"
            ref="popoverDuplicateProductType"
            header-text="Producttype dupliceren"
        >
            <div
                class="popover-contents"
                v-if="duplicated"
            >
                <div>
                    Er wordt een kopie gemaakt van #{{
                        duplicated.producttypeId
                    }}
                    - {{ duplicated.label }}
                </div>
                <div class="field">
                    <ui5-label>Nieuwe naam</ui5-label>
                    <ui5-input
                        type="Text"
                        :value="duplicatedName"
                        @input="duplicatedName = $event.target.value"
                    />
                </div>
                <div class="field">
                    <ui5-label>Nieuwe sleutel</ui5-label>
                    <ui5-input
                        type="Text"
                        :value="duplicatedKey"
                        @input="duplicatedKey = $event.target.value"
                    />
                </div>

                <spinner-text v-if="isDuplicating">
                    Bezig met dupliceren...
                </spinner-text>

                <div
                    slot="footer"
                    class="buttons"
                >
                    <ui5-button
                        @click="duplicate()"
                        :disabled="isDuplicating"
                    >
                        Bevestigen
                    </ui5-button>
                    <ui5-button
                        @click="$refs.popoverDuplicateProductType.close()"
                        :disabled="isDuplicating"
                    >
                        Annuleren
                    </ui5-button>
                </div>
            </div>
        </ui5-popover>
    </div>
</template>

<script>
import productTypeApi from '../../api/productType';
import SpinnerText from '../loader/SpinnerText';
import OutputHelper from '../../helpers/OutputHelper';
import { showInfoMessage, showErrorMessage } from '../../dialogs';
import IsDebugMixin from '../../mixins/is-debug';
import { getItemPath } from '../../shared/nestedStructure';

export default {
    mixins: [IsDebugMixin],
    components: { SpinnerText },
    props: ['suppliers', 'productTypes', 'productTypeGroups'],
    data() {
        return {
            filters: {
                label: {
                    value: '',
                    getter: (x) => x.label || '',
                },
                productTypeGroup: {
                    value: '',
                    getter: (x) =>
                        getItemPath(
                            x.productTypeGroupId,
                            this.productTypeGroups,
                            this.isDebug
                        ) || '',
                },
            },
            isDuplicating: false,
            duplicated: null,
            duplicatedKey: '',
            duplicatedName: '',
            suppliersById: null, // Index for O(1) lookups
        };
    },
    watch: {
        suppliers: {
            immediate: true,
            handler(newSuppliers) {
                if (newSuppliers) {
                    // Build index once - converts O(n) lookups to O(1)
                    this.suppliersById = newSuppliers.reduce((acc, supplier) => {
                        acc[supplier.id] = supplier;
                        return acc;
                    }, {});
                }
            }
        }
    },
    computed: {
        visibleProductTypes() {
            if (!this.productTypes) {
                return null;
            }

            const filters = Object.entries(this.filters);

            return this.productTypes.filter((type) => {
                let allMatch = true;
                for (const [key, filterData] of filters) {
                    const filterValue = filterData.value;
                    const typeVal = filterData.getter(type);
                    if (
                        filterValue &&
                        filterValue.length &&
                        !typeVal
                            .toLowerCase()
                            .includes(filterValue.toLowerCase())
                    ) {
                        allMatch = false;
                    }
                }
                return allMatch;
            });
        },
    },
    methods: {
        getItemPath: function () {
            return getItemPath(...arguments);
        },
        duplicate() {
            const id = this.duplicated.producttypeId;
            const key = this.duplicatedKey;
            const name = this.duplicatedName;
            this.isDuplicating = true;
            productTypeApi
                .duplicate(id, key, name)
                .then(() => {
                    showInfoMessage('Het producttype werd gedupliceerd', () => {
                        if (this.$refs.popoverDuplicateProductType) {
                            this.$refs.popoverDuplicateProductType.close();
                        }
                        this.$router.push(
                            '/producttypeDetails/' + data.data.id
                        );
                    });
                })
                .catch(() => {
                    showErrorMessage(
                        'Het producttype kon niet worden gedupliceerd'
                    );
                })
                .finally(() => {
                    this.isDuplicating = false;
                });
        },
        duplicateType($event, item) {
            this.duplicated = item;
            this.duplicatedKey = item.name + '-2';
            this.duplicatedName = item.label + '-2';
            this.$refs.popoverDuplicateProductType.showAt($event.target);
        },
        openEditProductionInfo(item) {
            this.$router.push('/editProductionInfo/' + item.producttypeId);
        },
        openEditType(id) {
            this.$router.push('/producttypeDetails/' + id);
        },
        openSawlineDetails(item) {
            this.$router.push('/producttypesawlinesedit/' + item.producttypeId);
        },
        outputBool(b) {
            return OutputHelper.boolToYesNo(
                b,
                OutputHelper.capitalization.allCaps
            );
        },
        getNameById(id) {
            if (!id || !this.suppliersById) {
                return '?';
            }
            // Use pre-built index for O(1) lookup instead of O(n) .find()
            const item = this.suppliersById[id];
            return item ? item.name : '?';
        },
    },
};
</script>
